var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"aside"},[_c('ModuleE',{staticClass:"aside-module-e"}),_c('ModuleA',{staticClass:"aside-module-a"}),_c('ModuleB',{staticClass:"aside-module-b"}),_c('ModuleD',{staticClass:"aside-module-d"}),_c('ModuleC',{staticClass:"aside-module-c"}),_c('ModuleF',{staticClass:"aside-module-f"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }